export default __webpack_public_path__ + "maps-examples-custom-style-thumbnail-480-e4916b182e23ceb37f84b965a18f0838.png";